import { z } from 'zod';
import { TaxTypeSchema } from './types';

export const AppliedTaxSchema = z.object({
    // taxRateId: 0 indicates external/unmapped tax (e.g., from Uber Eats, DoorDash) — the same sentinel OrderItem.menuItemId uses.
    taxRateId: z.number().int().nonnegative(),
    name: z.string().min(1),
    rate: z.number().min(0).default(0),
    type: TaxTypeSchema.default('none'),
    taxableBaseAmount: z.number().min(0).default(0),
    amountCalculated: z.number().min(0).default(0),
});

export const AppliedTaxDataSchema = z.object({
    // taxRateId: 0 indicates external/unmapped tax (e.g., from Uber Eats, DoorDash) — the same sentinel OrderItem.menuItemId uses.
    taxRateId: z.number().int().nonnegative(),
    name: z.string().min(1),
    rate: z.number().min(0).optional().default(0),
    type: TaxTypeSchema.optional().default('none'),
    taxableBaseAmount: z.number().min(0).optional().default(0),
    amountCalculated: z.number().min(0).optional().default(0),
});

export type AppliedTaxSchemaType = z.infer<typeof AppliedTaxSchema>;
export type AppliedTaxDataSchemaType = z.infer<typeof AppliedTaxDataSchema>;
